import React from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  // Inline Styles
  const styles = {
    landingContainer: {
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: '#333',
      margin: 0,
      padding: 0,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1.5rem 5%',
      background: '#fff',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    },
    logo: {
      fontSize: '1.8rem',
      color: '#2c5aa0',
      fontWeight: 700,
      margin: 0,
    },
    loginBtn: {
      padding: '0.75rem 2rem',
      background: '#2c5aa0',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    heroSection: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '3rem',
      padding: '5rem 5%',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '85vh',
    },
    heroContent: {
      animation: 'fadeInLeft 0.8s ease',
    },
    heroTitle: {
      fontSize: '3.5rem',
      color: '#1e3a70',
      marginBottom: '1.5rem',
      lineHeight: '1.2',
      fontWeight: 700,
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: '#555',
      marginBottom: '2.5rem',
      lineHeight: '1.6',
    },
    ctaButton: {
      padding: '1rem 2.5rem',
      background: '#ff6b6b',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1.1rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    heroImage: {
      animation: 'fadeInRight 0.8s ease',
    },
    heroImg: {
      width: '100%',
      height: 'auto',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    },
    featuresSection: {
      padding: '5rem 5%',
      background: '#fff',
      textAlign: 'center',
    },
    sectionTitle: {
      fontSize: '2.5rem',
      color: '#1e3a70',
      marginBottom: '3rem',
      fontWeight: 700,
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '2rem',
      marginTop: '3rem',
    },
    featureCard: {
      padding: '2rem',
      background: '#f8f9fa',
      borderRadius: '15px',
      transition: 'all 0.3s ease',
      border: '2px solid transparent',
    },
    featureIcon: {
      fontSize: '3rem',
      marginBottom: '1rem',
    },
    featureTitle: {
      fontSize: '1.5rem',
      color: '#2c5aa0',
      marginBottom: '1rem',
      fontWeight: 600,
    },
    featureText: {
      color: '#666',
      lineHeight: '1.6',
      fontSize: '1rem',
    },
    showcaseSection: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '4rem',
      padding: '5rem 5%',
      alignItems: 'center',
      background: '#f8f9fa',
    },
    showcaseContent: {
      textAlign: 'left',
    },
    showcaseTitle: {
      fontSize: '2.5rem',
      color: '#1e3a70',
      marginBottom: '1.5rem',
      fontWeight: 700,
    },
    showcaseText: {
      fontSize: '1.1rem',
      color: '#555',
      marginBottom: '2rem',
      lineHeight: '1.7',
    },
    showcaseList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    showcaseListItem: {
      fontSize: '1.1rem',
      color: '#333',
      marginBottom: '1rem',
      paddingLeft: 0,
    },
    showcaseImage: {
      width: '100%',
      height: 'auto',
      borderRadius: '20px',
      boxShadow: '0 15px 40px rgba(0, 0, 0, 0.2)',
    },
    ctaSection: {
      textAlign: 'center',
      padding: '5rem 5%',
      background: 'linear-gradient(135deg, #2c5aa0 0%, #1e3a70 100%)',
      color: 'white',
    },
    ctaSectionTitle: {
      fontSize: '2.5rem',
      marginBottom: '1rem',
      fontWeight: 700,
    },
    ctaSectionText: {
      fontSize: '1.2rem',
      marginBottom: '2.5rem',
      opacity: 0.9,
    },
    ctaButtonLarge: {
      padding: '1.2rem 3rem',
      background: '#ff6b6b',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1.2rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    footer: {
      background: '#1a1a1a',
      color: '#fff',
      textAlign: 'center',
      padding: '2rem 5%',
    },
    footerText: {
      opacity: 0.8,
      margin: 0,
    },
  };

  return (
    <div style={styles.landingContainer}>
      {/* Header Section */}
      <header style={styles.header}>
        <div>
          <h1 style={styles.logo}>🏨 HotelPro</h1>
        </div>
        <button 
          style={styles.loginBtn} 
          onClick={handleLoginClick}
          onMouseOver={(e) => {
            e.target.style.background = '#1e3a70';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(44, 90, 160, 0.3)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#2c5aa0';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Login
        </button>
      </header>

      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>
            Simplify Your Hotel Management
          </h1>
          <p style={styles.heroSubtitle}>
            Streamline operations, manage bookings, and enhance guest experiences 
            with our comprehensive hotel management solution.
          </p>
          <button 
            style={styles.ctaButton} 
            onClick={handleLoginClick}
            onMouseOver={(e) => {
              e.target.style.background = '#ee5a52';
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 6px 20px rgba(255, 107, 107, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#ff6b6b';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Get Started
          </button>
        </div>
        <div style={styles.heroImage}>
          <img 
            style={styles.heroImg}
            src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80" 
            alt="Luxury Hotel"
          />
        </div>
      </section>

      {/* Features Section */}
      <section style={styles.featuresSection}>
        <h2 style={styles.sectionTitle}>Why Choose HotelPro?</h2>
        <div style={styles.featuresGrid}>
          <div 
            style={styles.featureCard}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.borderColor = '#2c5aa0';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <div style={styles.featureIcon}>📅</div>
            <h3 style={styles.featureTitle}>Booking Management</h3>
            <p style={styles.featureText}>Effortlessly manage reservations, check-ins, and check-outs in real-time</p>
          </div>
          <div 
            style={styles.featureCard}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.borderColor = '#2c5aa0';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <div style={styles.featureIcon}>👥</div>
            <h3 style={styles.featureTitle}>Guest Management</h3>
            <p style={styles.featureText}>Keep track of guest profiles, preferences, and history</p>
          </div>
          <div 
            style={styles.featureCard}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.borderColor = '#2c5aa0';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <div style={styles.featureIcon}>🛏️</div>
            <h3 style={styles.featureTitle}>Room Management</h3>
            <p style={styles.featureText}>Monitor room availability, housekeeping, and maintenance</p>
          </div>
          <div 
            style={styles.featureCard}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.borderColor = '#2c5aa0';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <div style={styles.featureIcon}>📊</div>
            <h3 style={styles.featureTitle}>Analytics & Reports</h3>
            <p style={styles.featureText}>Get insights with detailed reports and analytics</p>
          </div>
        </div>
      </section>

      {/* Showcase Section */}
      <section style={styles.showcaseSection}>
        <div style={styles.showcaseContent}>
          <h2 style={styles.showcaseTitle}>Modern & Intuitive Interface</h2>
          <p style={styles.showcaseText}>
            Experience a clean, user-friendly dashboard designed for efficiency. 
            Manage your entire hotel operations from one powerful platform.
          </p>
          <ul style={styles.showcaseList}>
            <li style={styles.showcaseListItem}>✓ Real-time availability tracking</li>
            <li style={styles.showcaseListItem}>✓ Automated notifications</li>
            <li style={styles.showcaseListItem}>✓ Multi-user access control</li>
            <li style={styles.showcaseListItem}>✓ Mobile-responsive design</li>
          </ul>
        </div>
        <div>
          <img 
            style={styles.showcaseImage}
            src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80" 
            alt="Hotel Reception"
          />
        </div>
      </section>

      {/* CTA Section */}
      <section style={styles.ctaSection}>
        <h2 style={styles.ctaSectionTitle}>Ready to Transform Your Hotel Management?</h2>
        <p style={styles.ctaSectionText}>Join hundreds of hotels already using HotelPro</p>
        <button 
          style={styles.ctaButtonLarge} 
          onClick={handleLoginClick}
          onMouseOver={(e) => {
            e.target.style.background = '#ee5a52';
            e.target.style.transform = 'translateY(-3px)';
            e.target.style.boxShadow = '0 8px 25px rgba(255, 107, 107, 0.5)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#ff6b6b';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Login to Dashboard
        </button>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <p style={styles.footerText}>&copy; 2024 HotelPro Management System. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Landing;